<template>
  <transition name="fade">
    <div class="modal modal-mask" tabindex="-1" role="dialog" aria-hidden="true" @click.self="close()">
      <div class="modal-dialog modal-profile-picture h-100 my-0 mx-auto d-flex flex-column justify-content-center" role="document">
        <div class="modal-content bd-none">
          <i class="fa fa-close close-dialog" @click="close()"></i>

          <div class="modal-body px-0 py-0 upload-profile-picture">
            <div class="pt-4 px-4 text-left">
              <h2 class="t-primary t-500 mb-0">Upload a profile picture</h2>
              <hr class="hr-small mb-4" />
            </div>

            <div class="upload-profile-picture_wrapper mb-0 px-4">
              <!-- render avatar -->
              <avatar
                ref="avatar"
                :width="230"
                :height="230"
                :borderX="235"
                :borderY="0"
                :borderRadius="116"
                :image="image"
                @avatar:image-ready="onImageReady"
                v-show="isLoaded"
              ></avatar>

              <!-- content not loaded, show spinner -->
              <spinner v-if="!isLoaded" :containerClass="`h-100`" />
            </div>

            <p class="mb-3 py-3 t-white text-center photo-cropper__helper-text">
              Move the picture to change position
            </p>

            <div class="pb-4 px-4">
              <!-- render vue-avatar-scale -->
              <avatar-scale
                ref="avatarscale"
                @avatar:change-scale="onChangeScale"
                :width="351"
                :min="1"
                :max="3"
                :step="0.02"
              />

              <!-- render action buttons -->
              <div class="d-block clearfix mt-3 bd-t pt-4">
                <!-- render static messages -->
                <static-messages v-if="error" :messages="error" :variant="`danger`" @closed="error = null"/>

                <a href="#" v-if="image" class="t-regular t-600 t-sm pt-2 d-inline-block position-relative pull-left" @click.prevent="removeImage()">
                  <i class="fa fa-trash mr-2 t-red"></i>Remove picture
                </a>

                <form-buttons :isRequest="isRequest"
                  :isCancel="false"
                  :reference="`save`"
                  :containerClass="`bd-none pull-right m-reset pl-3`"
                  :btn="`mt-0`"
                  @save="saveImage()">
                </form-buttons>

                <div class="pull-right">
                  <label for="file" class="btn btn-secondary mb-0">Choose a picture</label>
                  <input
                    type="file"
                    name="file"
                    id="file"
                    class="btn-input-file"
                    accept="image/png, image/jpeg, image/gif, image/jpg"
                    @change="uploadImage($event)"
                  >

                  <!-- <button type="button" ref="save" class="btn btn-primary px-4 t-600 ml-3 position-relative" @click.prevent="saveImage()">
                    <i v-if="isRequest" class="fa fa-spinner fa-spin t-white fa-spin-left t-xxs"></i>
                    Save picture
                  </button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Avatar from '@/components/user/avatar/Avatar'
import AvatarScale from '@/components/user/avatar/AvatarScale'
import Spinner from '@/components/shared/Spinner'
import StaticMessages from '@/components/shared/StaticMessages'
import FormButtons from '@/components/shared/form/Buttons'

import UserService from '@/services/user'

export default {
  name: 'uploadProfilePicture',
  components: {
    Avatar,
    AvatarScale,
    Spinner,
    StaticMessages,
    FormButtons
  },
  props: {
    newImage: Event,
    image: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isRequest: false,
      isLoaded: false,
      error: null
    }
  },
  mounted () {
    if (this.newImage) this.$refs.avatar.fileSelected(this.newImage)
  },
  watch: {
    newImage (newVal, oldVal) {
      if (newVal !== oldVal) this.$refs.avatar.fileSelected(this.newImage)
    }
  },
  methods: {
    removeImage () {
      if (!this.isRequest) {
        this.isRequest = true
        UserService.deleteAvatar(this.$currentUser.user_id, { avatar: '' }).then(user => {
          this.$emit('updated', 'avatar', user.avatar)
          this.close()
          this.isRequest = false
        }).catch(err => {
          this.isRequest = false
          this.error = this.handleError(err)
        })
      }
    },
    uploadImage (e) {
      this.isLoaded = false
      this.$refs.avatar.fileSelected(e)
    },
    saveImage () {
      if (!this.isRequest) {
        this.isRequest = true

        let img = this.$refs.avatar.getImageScaled()
        let png = img.toDataURL('image/png', 1)

        UserService.updateAvatar(this.$currentUser.user_id, { avatar: png }).then(user => {
          this.$emit('updated', 'avatar', user.avatar)
          this.isRequest = false
          this.close()
        }).catch(err => {
          this.isRequest = false
          this.error = this.handleError(err)
        })
      }
    },
    onImageReady (scale) {
      this.isLoaded = true
      this.$refs.avatarscale.setScale(scale)
    },
    onChangeScale (scale) {
      this.$refs.avatar.changeScale(scale)
    },
    close () {
      this.$emit('closed')
    }
  }
}
</script>
